/* eslint-disable react-refresh/only-export-components --
   every export here IS a component (eight `lazy()` view chunks plus the
   shared `_AltViewFallback`), but the rule can't see the `lazy()` consts
   as components, so it flags the file as mixing components + non-components.
   This module is pure presentation with no HMR-stateful exports. */
import { lazy } from 'react'

// Arc 11 / audit P3#8 — lazy-load alternate views so the initial
// KanbanBoardView bundle (which 90%+ of operators render in `kanban`
// mode) doesn't pull table / calendar / gantt / swimlane chunks they
// may never click into. The fallback is intentionally minimal so the
// perceived behaviour is "view loads in <100ms" rather than a flash of
// empty space.
//
// Verbatim move out of KanbanBoardView.tsx (no behaviour change): the
// `lazy()` defs + `_AltViewFallback` lived inline; relocating them here
// keeps the host component leaner. Sibling view modules live one level
// up in `components/`, hence the `../` import specifiers.
export const BoardCalendarView = lazy(() =>
  import('../BoardCalendarView').then((m) => ({ default: m.BoardCalendarView })),
)
export const BoardGanttBucketView = lazy(() =>
  import('../BoardGanttBucketView').then((m) => ({
    default: m.BoardGanttBucketView,
  })),
)
// ARC-6 (U18-view) — Smart Time week/day allocation canvas. Lazy like the
// other alternate views so the flat board never downloads it unclicked.
export const BoardSmartTimeView = lazy(() =>
  import('../BoardSmartTimeView').then((m) => ({
    default: m.BoardSmartTimeView,
  })),
)
export const BoardGanttTimelineView = lazy(() =>
  import('../BoardGanttTimelineView').then((m) => ({
    default: m.BoardGanttTimelineView,
  })),
)
export const BoardSwimlaneView = lazy(() =>
  import('../BoardSwimlaneView').then((m) => ({ default: m.BoardSwimlaneView })),
)
export const BoardTableView = lazy(() =>
  import('../BoardTableView').then((m) => ({ default: m.BoardTableView })),
)
export const BoardCashFlowView = lazy(() =>
  import('../BoardCashFlowView').then((m) => ({ default: m.BoardCashFlowView })),
)
export const BoardCostIntelligenceView = lazy(() =>
  import('../BoardCostIntelligenceView').then((m) => ({
    default: m.BoardCostIntelligenceView,
  })),
)
// Arc V5 (kanban perf roadmap): the Split view is the heaviest alternate
// canvas (band stack + SplitBandNavigator + per-band lanes) yet was the only
// one statically imported, so it shipped in the flat-board bundle for every
// operator. Sibling file lives in THIS directory, hence './' not '../'.
// Note: viewSwitcherTypes.ts references it with `import type` only, which
// erases at compile time and does not defeat the chunk split.
export const BoardSwimlaneSplitView = lazy(() =>
  import('./BoardSwimlaneSplitView').then((m) => ({
    default: m.BoardSwimlaneSplitView,
  })),
)

export function _AltViewFallback() {
  return (
    <div className="flex items-center justify-center py-12 text-xs text-neutral-500">
      Loading view…
    </div>
  )
}
